import { Button, Fade, Grid, Typography } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router-dom";
import Logo from "../../img/loginLogo.png";
import Store from "../../redux/Store";
const RegisterFinelMessage = () => {
  const traceCode = Store.getState().loginReducer.traceCode;
  let [open, setOpen] = React.useState(false);
  const history = useHistory();
  React.useLayoutEffect(() => {
    setOpen(true);

    return () => {
      setOpen(false);
    };
  }, []);
  return (
    <Fade in={open} timeout={500}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        style={{ height: "100vh", backgroundColor: "#F2F2F6" }}
      >
        <Grid
          container
          item
          justifyContent="center"
          alignItems="center"
          direction="column"
          spacing={4}
          xs={12}
          sm={11}
          md={8}
          lg={7}
          style={{
            backgroundColor: "white",
            borderRadius: "20px",
            boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
            paddingTop: "1%",
            paddingBottom: "1%",
          }}
        >
          <Grid
            item
            container
            xs={12}
            md={11}
            lg={10}
            justifyContent="center"
            spacing={4}
            style={{ margin: "auto" }}
          >
            <Grid item xs={12} container justifyContent="center">
              <img src={Logo} alt="logo" />
            </Grid>
            <Grid item xs={12} justifyContent="center" container>
              <Typography variant="button">
                به پرینتر همراه خوش آمدید
              </Typography>
            </Grid>
            <Grid item xs={12} justifyContent="center" container>
              <Typography variant="button">
                درخواست با شماره پیگیری {traceCode} با موفقیت ثبت شد.بعد از
                بررسی کارشناسان
              </Typography>
            </Grid>
            <Grid item xs={12} justifyContent="center" container>
              <Typography variant="button">
                ما ، اکانت شما فعال خواهد شد
              </Typography>
            </Grid>
            <Grid item xs={12} justifyContent="center" container>
              <Typography variant="button">
                در صورت هرگونه سوال با کارشناسان ما تماس حاصل فرمایید
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              justifyContent="center"
              container
              direction="column"
              alignItems="center"
            >
              <Typography variant="button">
                شماره تماس : 44046279-021
              </Typography>
              <Typography variant="button">
                آدرس ایمیل : info@apatra.ir
              </Typography>
              <Button
                variant="contained"
                color="primary"
                style={{ marginTop: 16 }}
                onClick={() => {
                  history.push("/");
                }}
              >
                بازگشت به صفحه اصلی
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Fade>
  );
};

export default RegisterFinelMessage;
